import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const HealthcareHomeIcon = createIcon({
  displayName: 'HealthcareHomeIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M8.5,20V15a1,1,0,0,1,1-1H11"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21,16.2a.8.8,0,0,0-.8-.8H18.6V13.8a.8.8,0,0,0-.8-.8H16.2a.8.8,0,0,0-.8.8v1.6H13.8a.8.8,0,0,0-.8.8v1.6a.8.8,0,0,0,.8.8h1.6v1.6a.8.8,0,0,0,.8.8h1.6a.8.8,0,0,0,.8-.8V18.6h1.6a.8.8,0,0,0,.8-.8Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,10.58027,10.6984,3.9815a2,2,0,0,1,2.6032,0L21,10.58027"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="10"
        y1="20"
        x2="3"
        y2="20"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15.62359,5.97182V3.75a.75.75,0,0,1,.75-.75H18.9645a.75.75,0,0,1,.75.75V9.47839"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M4.2855,9.47839V20"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const HealthcareHome: FC<IconProps> = (props) => {
  return <CustomIcon as={HealthcareHomeIcon} {...props} />
}

export default memo(HealthcareHome)
